import Button from '@viking-eng/button';
import Container from '@viking-eng/container';
import Icon from '@viking-eng/icon';
import PropTypes from '@viking-eng/prop-types';
import { getAccessibilityFunctions, prepareHtml } from '@viking-eng/utils';
import React from 'react';
import './Footer.css';

// Footer component
// items: links to display
// copyright: Copyright data

function Footer({ copyrightText, leftMenuHeader, leftMenuItems, rightMenuHeader, rightMenuItems }) {
  const mapModalAttributes = (item = {}) => {
    const sameTab = [false, 'false'].includes(item.newBrowserTab);
    if (sameTab) {
      if (item.modalVersionTwo) {
        return {};
      }
      return {
        'data-toggle': 'modal',
        'data-target': item.modalId || '',
        rel: 'noopener noreferrer',
        target: '',
      };
    }
    return { target: '_blank' };
  };

  const getLinkButton = (item) => {
    const modalAttributes = mapModalAttributes(item);
    return (
      <Button
        appearance="link"
        className={item.className}
        id={item.id}
        key={item.id}
        aria-label={item.text}
        onButtonClick={item.onClick}
        onContextMenu={item.onContextMenu}
        {...modalAttributes}
        {...getAccessibilityFunctions()}
      >
        {item.icon && <Icon name={item.icon} />}
        {item.text && <span className="title-highlight" dangerouslySetInnerHTML={prepareHtml(item.text)} />}
      </Button>
    );
  };
  return (
    <footer className="footer-wrapper">
      <div className="footer-container">
        <Container>
          <div className="footer row">
            <div className="left-menu-item col-sm-6 col-md col-12">
              {leftMenuHeader && (
                <span dangerouslySetInnerHTML={prepareHtml(leftMenuHeader)} className="h6 left-menu-header" />
              )}
              <ul id="footerItems" className="list-unstyled footer-item align-self-center">
                {leftMenuItems &&
                  leftMenuItems.map((item, index) => (
                    <li key={index} className="information-links h7">
                      {getLinkButton(item)}
                    </li>
                  ))}
              </ul>
            </div>
            <div className="right-menu-items col-sm-6 col-md-auto col-12">
              <span dangerouslySetInnerHTML={prepareHtml(rightMenuHeader)} />
              {rightMenuItems && !!rightMenuItems.length && (
                <div className="connect-items">{rightMenuItems.map((item) => getLinkButton(item))}</div>
              )}
              <div
                id="footerCopyright"
                className="footer-copyright h7"
                dangerouslySetInnerHTML={prepareHtml(copyrightText)}
              />
            </div>
          </div>
        </Container>
      </div>
    </footer>
  );
}

const footerItemType = PropTypes.shape({
  text: PropTypes.string,
  id: PropTypes.string,
  modalId: PropTypes.string,
  modalVersionTwo: PropTypes.bool,
  name: PropTypes.string,
  newBrowserTab: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  onClick: PropTypes.func,
  onContextMenu: PropTypes.func,
  icon: PropTypes.string,
  url: PropTypes.string,
});

Footer.propTypes = {
  copyrightText: PropTypes.string,
  handleModalOpen: PropTypes.func.isRequired,
  leftMenuHeader: PropTypes.string,
  leftMenuItems: PropTypes.arrayOf(footerItemType),
  rightMenuHeader: PropTypes.string,
  rightMenuItems: PropTypes.arrayOf(footerItemType),
};
Footer.defaultProps = {
  copyrightText: '',
  leftMenuHeader: '',
  leftMenuItems: [],
  rightMenuHeader: '',
  rightMenuItems: [],
};

export default Footer;
